import { GroupForBookingFormQuery } from '@website/types/graphqlOperations';
import { Card } from 'react-bootstrap';
import { Image } from '../media/utils/imgix';

export default function BookingColumn({
  trip,
}: {
  trip: Pick<GroupForBookingFormQuery['group']['trip'], 'image'>;
}) {
  return (
    <Card className="border-0 shadow">
      <Image
        imgKey={trip.image.file.key}
        imgixParams={{
          auto: 'compress,format,enhance,redeye',
          crop: 'faces',
          fit: 'crop',
          ar: `1.5:1`, // Aspect ratio
        }}
        className="w-100 h-100 rounded-top"
        sizes="(min-width: 1400px) 490px, (min-width: 1200px) 415px, (min-width: 992px) 376px, (min-width: 768px) 276px, 100vw"
      />

      <Card.Footer className="bg-primary-light py-4 border-0">
        <div className="d-flex align-items-center">
          <div>
            <h6 className="text-primary">Flexible booking</h6>
            <p className="text-sm text-primary opacity-8 mb-0">
              You can change dates for free on most trips, any time up to 2
              months before departure.
            </p>
          </div>
        </div>
      </Card.Footer>
    </Card>
  );
}
